import React,{useState,useEffect} from "react"
import Slider from "react-slick"
import "./Slider.scss"
import arrow from "../assets/icons/forward.png"
import { Link } from "react-router-dom"
import { logEvent } from '../Analytics/AnalyticsEvent';
import { screen, events } from '../Analytics/EventName';
import { reactLocalStorage } from "reactjs-localstorage"
import starLink from "./../assets/icons/complete.png"
import baneer from "../assets/images/banners/banner1.png"
import "../AppComponents/Games.scss"
function BannerSlider(props) {
    console.log('inside GamesSlider Component')
    const { settings, data, title,icon,category,btn_color,view_all,play_btn_txt} = props
    const [loading,setLoading]=useState(false)
    const slideritems = data.map((item, i) => (
        <Link to={`/game/${item.category}/${item.id}`} key={i}>
          <div
            className="slider-card"
            onClick={() => {
              logEvent(
                {
                  screen: screen.homePage,
                  event: item.gameName + "_cardClick",
                },
                {
                  gameName: item.gameName,
                  mobile: reactLocalStorage.get("msisdn"),
                  date: new Date(),
                }
              );
              localStorage.setItem("category_data",JSON.stringify(data))
              localStorage.setItem("category_name",JSON.stringify(title))
              
            }}
          >
            <div className="card-image">
              <figure className="image is-1by1">
                <img src={item.gameImage} alt={item.title} className="img-radius" />
              </figure>
            </div>
            <div className="flex">
              <div className="flex-left">
                <h6 className="mb-0 text-white">{item.gameName}</h6>
              </div>
              <div className="flex-right text-white">
                <figure className="display">
                  <img src={starLink} className="star-icon rating-icon" />
                  {item.ratings}
                </figure>
              </div>
            </div>
          </div>
        </Link>
    ));
    return (
        <div className="columns is-multiline is-mobile common is-gapless">
            <div className="column is-full v-center display">
                <div className="border-left">
                <span className="title is-6 mb-0 capatalize text-white mr-2">{title}</span>
                <img className="cat-icon" src={icon}/>
               
                </div>
                                <Link className="is-small ml-auto text-white bg toggle-btn" style={{background:btn_color}}  to={{pathname:"/category",state:{categoryData:data,datacategory:data[0].category}}} >
                               {view_all}
                    <img src={arrow} alt="arrow" className="ml-1" />
                </Link>              
            </div>
            <div className="column is-full" >
                <Slider {...settings}>
                    {slideritems}
                </Slider>
            </div>
        </div>
    )
}

export default BannerSlider